import React, { memo, useState, useCallback, useEffect, useMemo } from 'react';
import { useForm, Controller } from 'react-hook-form';
import toast from 'react-hot-toast';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import { makeGetRequest, makeRequest } from '../../util/http-client';
import { resolver } from './reset-password.schema';
import { withRouter } from 'react-router-dom';

const ResetPasswordForm = memo(({ form, serverError, onSubmit }) => {
	const {
		control,
		formState: { isValid },
		handleSubmit,
	} = form;

	return (
		<div className="login-form__backdrop">
			<div className="login-form__container">
				<h3 className="login-form__header">Новый пароль</h3>
				<div className="login-form__row">
					<Controller
						name="password"
						control={control}
						render={({ field: { onChange, value }, fieldState: { error } }) => (
							<TextField
								value={value}
								type="password"
								errorText={error ? error.message : undefined}
								hintText="Пароль"
								floatingLabelText="Пароль"
								fullWidth
								onChange={onChange}
							/>
						)}
					/>
				</div>
				<div className="login-form__row">
					<Controller
						name="confirmPassword"
						control={control}
						render={({ field: { onChange, value }, fieldState: { error } }) => (
							<TextField
								value={value}
								hintText="Повторить"
								errorText={error ? error.message : undefined}
								floatingLabelText="Повторить"
								type="password"
								fullWidth
								onChange={onChange}
							/>
						)}
					/>
				</div>
				<div className="login-form__row">
					<RaisedButton label="Обновить" disabled={!isValid} primary onClick={handleSubmit(onSubmit)} />
				</div>
			</div>
		</div>
	);
});

export const ResetPasswordFormContainer = withRouter(props => {
	const { userId, token } = props.match.params;
	const [serverError, setServerError] = useState(null);

	const form = useForm({
		mode: 'onChange',
		resolver,
		defaultValues: {
			password: '',
			repeat: '',
		},
	});

	const link = useMemo(() => `password-reset/${userId}/${token}`, [userId, token]);

	useEffect(() => {
		makeGetRequest(link).then(resp => {
			if (resp.status !== 200) {
				toast.error('Вы перешли по ссылке содержащей неверные данные.');
				props.history.replace('/');
			}
		});
	}, [link]);

	const handleSubmit = useCallback(
		async data => {
			try {
				await makeRequest(link, data);
				toast.success('Вы успешно изменили пароль');
			} catch (e) {
				toast.error('Во время смены пароля, произошли ошибки');
			}
			props.history.replace('/');
		},
		[userId, token],
	);

	return <ResetPasswordForm form={form} onSubmit={handleSubmit} serverError={serverError} />;
});



// WEBPACK FOOTER //
// src/components/reset-password/reset-password-form.jsx